import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { AppConfig } from 'AppConfig';
import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import * as AppActionTypes from 'store/actions/appstate';
import { store } from 'store/store';
import LocalStore from 'utils/LocalStore';
import { DIJobsTable } from './DIJobsTable';

const DIJobsComponent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [statusData, setStatusData] = useState([]);
  const diInterval = useRef(null);

  useEffect(() => {
    return () => {
      if (diInterval.current) clearInterval(diInterval.current);
    };
  }, []);

  const getDIJObId = async () => {
    try {
      setIsLoading(true);
      const apiResponse = await fetch(
        AppConfig.API_BASE_URL + `dijob/getDIJobId`,
        {
          method: 'get',
          headers: {
            Authorization: 'Bearer ' + LocalStore.getAccessToken()
          }
        }
      );
      if (!apiResponse.ok) {
        throw new Error('Cannot get DI Job Id');
      }
      const id = await apiResponse.text();
      if (!id) {
        store.dispatch({
          type: AppActionTypes.APPSTATE_SET_APP_ERROR,
          payload: 'No DI Jobs status found!.'
        });
      }
      setIsLoading(false);
      return id;
    } catch (error) {
      setIsLoading(false);
      console.log(error.message);
      return undefined;
    }
  };

  const fetchDIJobStatus = async (jobId) => {
    setIsLoading(true);
    try {
      const statusResponse = await fetch(
        AppConfig.API_BASE_URL + `dijob/getStatusById?jobId=${jobId}`,
        {
          method: 'get',
          headers: {
            Authorization: 'Bearer ' + LocalStore.getAccessToken()
          }
        }
      );
      if (!statusResponse.ok) {
        throw new Error('Network Error');
      }
      const diJobStatusData = await statusResponse.json();
      if (diJobStatusData) {
        const modifiedData = diJobStatusData
          .sort((a, b) => new Date(b.createdDttm) - new Date(a.createdDttm))
          .map((row) => ({
            jobId: row.jobId,
            jobName: row.jobName,
            process: row.process,
            status: row.status
          }));
        setStatusData(modifiedData);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      store.dispatch({
        type: AppActionTypes.APPSTATE_SET_APP_ERROR,
        payload: error.message
      });
    }
  };

  const onGetDIJobStatusClick = async () => {
    const latestJobId = await getDIJObId();
    if (latestJobId) {
      if (diInterval.current) clearInterval(diInterval.current);
      diInterval.current = setInterval(() => {
        const hasJobCompleted = statusData.find(
          ({ process, status }) =>
            process.toLowerCase() === 'masterdata loading job' &&
            status.toLowerCase() === 'success'
        );
        console.log('hasJobCompleted', hasJobCompleted);
        if (hasJobCompleted) {
          clearInterval(diInterval.current);
          return;
        }
        fetchDIJobStatus(latestJobId);
      }, 5000);
    }
  };

  const onExecute = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(AppConfig.API_BASE_URL + `dijob`, {
        method: 'get',
        headers: {
          Authorization: 'Bearer ' + LocalStore.getAccessToken()
        }
      });
      if (!response.ok) {
        throw new Error('FMR/MPR job execution failed.');
      }
      setIsLoading(false);
      store.dispatch({
        type: AppActionTypes.APP_REST_CALL_SUCESSED,
        payload: 'FMR/MPR job execution success.'
      });
    } catch (error) {
      setIsLoading(false);
      store.dispatch({
        type: AppActionTypes.APPSTATE_SET_APP_ERROR,
        payload: error.message
      });
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Box
        sx={{
          border: 1,
          borderColor: 'primary.main',
          borderRadius: 2,
          p: 3,
          mb: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap'
        }}
      >
        <Typography variant="h6" sx={{ ml: 1 }}>
          FMR/ MPR Job
        </Typography>
        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<CheckCircleOutlineIcon />}
            onClick={onExecute}
            disabled={isLoading}
          >
            Execute
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<ListAltOutlinedIcon />}
            onClick={onGetDIJobStatusClick}
            disabled={isLoading}
          >
            Get DI Jobs Status
          </Button>
        </Stack>
      </Box>
      {isLoading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
          <CircularProgress />
        </Box>
      )}
      {statusData.length > 0 && (
        <Box sx={{ p: 3, mb: 2 }}>
          <Typography variant="h5" align="center" gutterBottom>
            DI Jobs Status
          </Typography>
          <DIJobsTable rows={statusData} />
        </Box>
      )}
    </Container>
  );
};

const mapStateToPropsSelector = createStructuredSelector({});

export const DiJobs = connect(mapStateToPropsSelector)(DIJobsComponent);
